import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import EditNewsForm from './EditNewsForm'

import {
  getCurrentUserRepresentatives,
  getLimitedRepresentativeStores,
  getLimitedStores,
} from '../../../store/actions/store-info-actions'
import { saveNewsArticle } from '../../../store/actions/news-actions'
import { getNewsArticleAndStores } from '../../../store/actions/news-store-info-actions'
import { useOnMount } from '../../../util/utility-hooks'

const EditNewsContainer = ({
  role,
  articleId,
  currentArticle,
  fetchNewsArticleAndStores,
  fetchCurrentUserRepresentatives,
  saveArticle,
  onBack,
  fetchRepresentativeStores,
  fetchLimitedStores,
  representatives,
}) => {
  const [done, setDone] = useState(false)
  const [stores, setStores] = useState([])
  const [newsStores, setNewsStores] = useState([])

  useOnMount(() => {
    if (articleId) {
      fetchNewsArticleAndStores(articleId)
    }
    fetchCurrentUserRepresentatives()
  })

  const onSave = entry => {
    saveArticle(entry).then(() => {
      if (!articleId) {
        setDone(true)
      } else {
        onBack()
      }
    })
  }

  const getAndSaveRepresentativeStores = repId => {
    fetchRepresentativeStores(repId).then(s => setStores([...s]))
  }

  const getNewsStores = storeIds =>
    fetchLimitedStores(storeIds).then(s => {
      setNewsStores([...s])
      return s
    })

  if (done) {
    return <Redirect to="/news/admin" />
  }
  if (articleId && !currentArticle) {
    return null
  }
  return (
    <EditNewsForm
      role={role}
      representatives={representatives}
      stores={stores}
      newsStores={newsStores}
      article={articleId ? currentArticle : null}
      getRepresentativeStores={getAndSaveRepresentativeStores}
      getNewsStores={getNewsStores}
      onSave={onSave}
      onBack={onBack}
    />
  )
}

EditNewsContainer.propTypes = {
  role: PropTypes.string.isRequired,
  representatives: PropTypes.array.isRequired,
  fetchRepresentativeStores: PropTypes.func.isRequired,
  fetchLimitedStores: PropTypes.func.isRequired,
  saveArticle: PropTypes.func.isRequired,
  fetchNewsArticleAndStores: PropTypes.func.isRequired,
  fetchCurrentUserRepresentatives: PropTypes.func.isRequired,
  articleId: PropTypes.string,
  currentArticle: PropTypes.object,
  onBack: PropTypes.func,
}

EditNewsContainer.defaultProps = {
  articleId: null,
  currentArticle: null,
  onBack: null,
}

const mapStateToProps = state => ({
  role: state.auth.role,
  representatives: state.storeInfo.representatives,
  currentArticle: state.news.adminNews.currentArticle,
})

const mapDispatchToProps = dispatch => ({
  fetchCurrentUserRepresentatives: () => {
    dispatch(getCurrentUserRepresentatives())
  },
  fetchRepresentativeStores: representativeId =>
    dispatch(getLimitedRepresentativeStores(representativeId)),
  fetchLimitedStores: storeIds => dispatch(getLimitedStores(storeIds)),
  saveArticle: newsEntry => dispatch(saveNewsArticle(newsEntry)),
  fetchNewsArticleAndStores: articleId => {
    dispatch(getNewsArticleAndStores(articleId))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(EditNewsContainer)
